import 'reflect-metadata';
export class Record {
    constructor() {
        this.id = -1;
    }
}
